module.exports = __webpack_public_path__ + "static/media/info-ellipse.7607d096.svg";